export const TIME_MASK = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
export const APP_VERSION: string = '2025.51.1';
